import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { GlobalFleetContactCollection } from './global-fleet-contact.types';

export function globalFleetContactBackend(): Backend<GlobalFleetContactCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (authUid, globalFleetContact) => ({
      asFormData: true,
      endpoint: 'enterprise/enquiry.php',
      isGaf: true,
      payload: {
        first_name: globalFleetContact.firstName,
        last_name: globalFleetContact.lastName,
        company_name: globalFleetContact.companyName,
        email: globalFleetContact.email,
        contact_number: globalFleetContact.contactNumber,
        company_size: globalFleetContact.companySize,
        country: globalFleetContact.country,
        enquiry: globalFleetContact.enquiry,
        captcha_response: globalFleetContact.captchaResponse,
        source: 'globalfleet',
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
